import { render } from "./deleteRecords.vue?vue&type=template&id=d58c4572&scoped=true"
import script from "./deleteRecords.vue?vue&type=script&lang=js"
export * from "./deleteRecords.vue?vue&type=script&lang=js"

import "./deleteRecords.vue?vue&type=style&index=0&id=d58c4572&scoped=true&lang=css"
import "./deleteRecords.vue?vue&type=style&index=1&id=d58c4572&lang=css"
script.render = render
script.__scopeId = "data-v-d58c4572"

export default script